import classNames from "classnames";
import isString from "lodash/isString";
import React from "react";
import { useCopies } from "shared/hooks/useCopies";

/**
 * Displays value counter for field.
 * @todo TODO:ANS make this counter floating and inside view at two placed passing custom classes, remove them if not required.
 */
function FieldValueCount(props: FieldValueCountProps) {
  const copies = useCopies();

  const count = React.useMemo(() => {
    if (isString(props.value)) {
      return props.value.trim().length;
    }
    return props.value || 0;
  }, [props.value]);

  return (
    <span className={classNames("textBox_count", props.className)}>
      {props.maxCount !== undefined && props.maxCount > 0 ? (
        <span>
          {copies.get("field.value.count", {
            0: count,
            1: props.maxCount
          })}
        </span>
      ) : props.showCharacterCount ? (
        <span>
          {copies.get("total.characters.count", {
            0: count
          })}
        </span>
      ) : null}
    </span>
  );
}

export default FieldValueCount;
